import { useState, useEffect } from "react";
import "./App.css";
import axios from "axios";

import {
  Loading,
  AboutMe,
  AppNavbar,
  Banner,
  Skills,
  AppProjects,
  Footer,
  ContactMe,
} from "../src/components";
import getEmailConfig from "./utils/emailConfig";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Container, Row } from "react-bootstrap";

function App() {
  /* Page */
  const [activePage, setActivePage] = useState("home");
  /* Loading */
  const [isLoading, setIsLoading] = useState(true);

  //Get Location
  // const [location, setLocation] = useState({});

  const getLocation = async () => {
    try {
      const response = await axios.get(
        `https://ipinfo.io/json?token=${process.env.REACT_APP_IP_API}`
      );

      return response.data;
    } catch (error) {}
  };

  //Send Email
  const sendEmail = async () => {
    //Delay Sending Email
    setTimeout(async () => {
      try {
        if (window.Email) {
          const location = await getLocation();

          const { ip, city, region, country, loc, org, postal, timezone } =
            location;

          //Send Mail Only if location is available
          if (location !== undefined) {
            window.Email.send(
              getEmailConfig(
                "info@kaamilahamadh.online",
                "owner@kaamilahamadh.online",
                "New User - Just Visited",
                // `${JSON.stringify(location)}`
                ` <html>
              <h2> New User </h2>
              <br />

              IP: ${ip} <br />
              City: ${city} <br />
              Region: ${region} <br />
              Country: ${country} <br />
              Location: ${loc} <br />
              ISP: ${org} <br />
              Postal: ${postal} <br />
              Timezone: ${timezone} <br />
              </html>
              `
              )
            )
              .then((message) => {
                // alert(message);
              })
              .catch((err) => {
                console.log(err);
              });
          }
        }
      } catch (error) {}
    }, 100);
  };

  useEffect(() => {
    //Send Email
    sendEmail();

    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, []);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className="app">
      <AppNavbar />

      <ToastContainer
        position="top-center"
        theme="dark"
        toastStyle={{
          backgroundColor: "#1e40af",
          fontWeight: "bold",
          fontFamily: "poppins",
          borderRadius: "5rem",
        }}
      />

      <div className="gradient-bg-services">
        <br />
        <br />
        <div className="text-light m-4">Welcome to My Portfolio</div>

        <Banner />
        <AboutMe />
        <Skills />
        <AppProjects />
        <ContactMe />

        <Footer />
      </div>
    </div>
  );
}

export default App;
